import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('FlexUiMenuController', FlexUiMenuController);

    function FlexUiMenuController() {
        var vm = this;

        vm.checkIsAllTrue = function (data) {
            return data.every(isAllTrue);
        };

        vm.addActive = function (e) {
            angular
                .element(e.currentTarget)
                .find('.position-relative .flex-list')
                .addClass('active');
        };

        vm.removeActive = function (e) {
            angular
                .element(e.currentTarget)
                .find('.position-relative .flex-list')
                .removeClass('active');
        };

        function isAllTrue(element, index, array) {
            return !element.if;
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/flex-ui/menu/flex-ui-menu.controller.ts